import { AccountObjectFacade } from "../account-object/account-object.facade";
import { Membership } from "./membership.model";
import { MembershipApiFacade } from "./membership.api-facade";
import { MembershipStoreFacade } from "./membership.store-facade";

export class MembershipFacade extends AccountObjectFacade<Membership, MembershipApiFacade, MembershipStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.facade.ts